import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { PersongbControllerService, PersongbDTO } from '../../../target/generated-sources/openapi';

@Injectable({
  providedIn: 'root'
})
export class PersongbResolver implements Resolve<PersongbDTO> {

  constructor(private backend: PersongbControllerService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PersongbDTO> {
    const id = route.paramMap.get('id');
    if (!id) {
      return EMPTY;
    }
    return this.backend.getPersongbById(id);
  }
}
